import FlexBox from '../components/Box/FlexBox.styled';
import Page from '../components/Page/Page';
import Text from '../components/Text/Text.styled';
import React from 'react';

const Homepage = () => {
  return (
    <Page>
      <FlexBox minHeight="100vh" justifyContent="center" alignItems="center">
        <Text variant="label">Comming soon</Text>
      </FlexBox>
    </Page>
  );
};

export default Homepage;
